import React, { useContext, useState } from "react";
import {
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	Paper,
	TableContainer,
	TableFooter,
	LinearProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Loading from "../../../../components/loading";
import { ContextRegisterSupplier } from "../context";
import "./style.css";
import CustomPagination from "../../../paginate";

const itemsPerPage = 15; // Quantidade de itens por página

function TableSupplier({ isSelector, onSelectSupplier, ...props }) {
	const {
		supplierData,
		openModalRegisterSupplier,
		totalPage,
		page,
		setPage,
		currentPage,
		fetchSupplierPaginate,
		loading,
	} = useContext(ContextRegisterSupplier);

	const handleChangePage = (event, newPage) => {
		//se a pagina não foi carregada faz a pesquisa no banco
		if (newPage > currentPage.current) {
			fetchSupplierPaginate();
		}

		if (totalPage > 0) {
			if (newPage > totalPage) return;
		}

		setPage(newPage);
	};

	// const handleChangePage = (event, newPage) => {
	// 	setPage(newPage);
	// };

	const startIndex = (page - 1) * itemsPerPage;
	const endIndex = startIndex + itemsPerPage;
	const slicedData = supplierData.slice(startIndex, endIndex);

	return (
		<>
			{props.loading ? (
				<Loading />
			) : (
				<>
					{/* <Paper> */}
					<TableContainer component={Paper}>
						<Table>
							<TableHead className="color-table">
								<TableRow>
									<TableCell
										style={{
											width: "80",
											whiteSpace: "nowrap",
										}}
									>
										<span className="text-color-table">Nome Fantasia</span>
									</TableCell>
									<TableCell
										style={{
											width: "80",
											whiteSpace: "nowrap",
										}}
									>
										<span className="text-color-table">Ração Social</span>
									</TableCell>
									<TableCell style={{ width: "200px" }}>
										<span className="text-color-table">Endereço</span>
									</TableCell>
									<TableCell style={{ width: "150px" }}>
										<span className="text-color-table">Bairro</span>
									</TableCell>
									<TableCell style={{ width: "50px" }}>
										<span className="text-color-table">Celular</span>
									</TableCell>

									<TableCell style={{ width: "50px" }}>
										<span className="text-color-table">Ativo</span>
									</TableCell>

									<TableCell
										style={{
											width: "50px",
											textAlign: "center",
											verticalAlign: "middle",
										}}
									></TableCell>
									{isSelector && <TableCell style={{ width: "100px", textAlign: "center" }}><span className="text-color-table">Selecionar</span></TableCell>}
								</TableRow>
							</TableHead>
							<TableBody>
								{slicedData.map((item, key) => (
									<TableRow key={key} className="zebra-row">
										<TableCell style={{ whiteSpace: "nowrap" }}>{item.fantasia}</TableCell>
										<TableCell style={{ whiteSpace: "nowrap" }}>{item.nome}</TableCell>
										<TableCell style={{ whiteSpace: "nowrap" }}>{item.rua}</TableCell>
										<TableCell style={{ whiteSpace: "nowrap" }}>{item.bairro}</TableCell>
										<TableCell style={{ whiteSpace: "nowrap" }}>{item.telefone_1}</TableCell>
										<TableCell style={{}}>{item.ativo}</TableCell>
										<TableCell style={{}}>
											<button
												className="btn btn-sm btn-outline-primary"
												onClick={(e) => openModalRegisterSupplier(item)}
											>
												<EditIcon />
											</button>
										</TableCell>
										{isSelector && (
											<TableCell style={{ textAlign: "center", verticalAlign: "middle" }}>
												<button className="btn btn-sm btn-outline-success" onClick={() => onSelectSupplier && onSelectSupplier(item)}>
													Selecionar
												</button>
											</TableCell>
										)}
									</TableRow>
								))}
							</TableBody>
							{loading ? (
								<TableFooter>
									<TableRow>
										<TableCell colSpan={document.querySelectorAll("thead th").length}>
											<LinearProgress variant="indeterminate" />
										</TableCell>
									</TableRow>
								</TableFooter>
							) : (
								supplierData.length === 0 && (
									<TableRow>
										<TableCell
											colSpan={document.querySelectorAll("thead th").length}
											className="italic text-gray-400"
										>
											Nenhum registro encontrado.
										</TableCell>
									</TableRow>
								)
							)}
						</Table>
						{/* {loading && (
							<div className="flex h-44">
								<Loading mensagem={"Carregando dados dos fornecedores"} />
							</div>
						)} */}
						{supplierData?.length > 0 && (
							<CustomPagination
								count={Math.ceil(supplierData.length / itemsPerPage)}
								page={page}
								onChangePage={handleChangePage}
								totalRecord={supplierData.length}
								totalPage={totalPage}
								itemsPerPage={itemsPerPage}
							/>
						)}
					</TableContainer>
					{/* </Paper> */}
				</>
			)}
		</>
	);
}

export default TableSupplier;
